import z from 'zod/v4';

// Max 50 keys
export const DefaultPresetDataSchema = z.object({
  version: z.string(),
  presetData: z.string(),
  createdAt: z.iso.datetime({ offset: true }),
  createdBy: z.uuid(),
  updatedAt: z.iso.datetime({ offset: true }),
  updatedBy: z.uuid(),
});

export const DefaultPresetSchema = z.object({
  name: z.string().refine((val) => val.length <= 256),
  context: z.string().refine((val) => val.length <= 256),
  key: z.string().refine((val) => val.length <= 256),
  owner: z.union([
    z.templateLiteral([z.literal('public'), ':', z.uuid()]),
    z.templateLiteral([z.literal('private'), ':', z.uuid(), ':', z.uuid()]),
  ]),
  data: DefaultPresetDataSchema,
});
